import { useContext, useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { FirebaseContext } from '@/session/FirebaseContext';
import { ACTIVE_TOURNAMENT } from '@/constants';
import type { GroupStandingsSnapshot } from '@/models/groupStandings';

const GROUP_STANDINGS_DOC_ID = 'current';

/** Live WC-26 group standings from Firestore (public read). */
export function useGroupStandings(): GroupStandingsSnapshot | null {
  const ctx = useContext(FirebaseContext);
  const [snapshot, setSnapshot] = useState<GroupStandingsSnapshot | null>(null);

  useEffect(() => {
    return onSnapshot(
      doc(ctx.db, 'competitions', ACTIVE_TOURNAMENT, 'groupStandings', GROUP_STANDINGS_DOC_ID),
      (docSnap) => {
        if (docSnap.exists()) {
          setSnapshot(docSnap.data() as GroupStandingsSnapshot);
        } else {
          setSnapshot(null);
        }
      },
      (error) => {
        console.error(error);
      },
    );
  }, [ctx.db]);

  return snapshot;
}
